import {IModel} from "../../../kova/slsordClient";
import {useModelOptContext} from "../../../data/modelSource";
import {useMemo, useState} from "react";
import {IConfiguratorProxy, IOptionItemChoice} from "@bimaire/optionslib";
import {Client} from "OptConfigurator";
import KovaConfigurator from "@bimaire/optionslib-kova/build/loaders/kova/kovaConfigurator";

export function useModelConfigurator(model: IModel) {
    const modelContext = useModelOptContext(model.id);
    const [configurator, setConfigurator] = useState<IConfiguratorProxy | null>(null);

    const loadedConfigurator = useMemo(() => {
            if (modelContext === null) return null;
            const parsedModelContext = JSON.parse(modelContext);
            if (!parsedModelContext.ConfParamsContext) {
                parsedModelContext.ConfParamsContext = {
                    IsLotTypeMarket: false,
                    MarketHomesEnableOptionSelections: true,
                    ShowSelectedExpiredOptions: false
                }
            }
            if (!parsedModelContext.OptContextCustomFields) {
                parsedModelContext.OptContextCustomFields = {CustomFields: []};
            }

            const config = Client.loadFromJSON(parsedModelContext);
            (window as any).optState = config; // for easy troubleshooting
            const kovaConfigurator = new KovaConfigurator(null);
            return kovaConfigurator.getConfiguratorProxy(config) as IConfiguratorProxy;
        },
        [model.id, modelContext !== null]);
    if (modelContext === null) return {
        configurator: null, onSelect: () => {
        }
    };
    const configuratorToUse = configurator ?? loadedConfigurator;

    const onSelect = (opt: IOptionItemChoice) => {
        const configuratorToUse2 = configurator ?? loadedConfigurator;

        if (configuratorToUse2 === null) return;
        setConfigurator(conf => (conf ?? loadedConfigurator!).applyChoice(opt));

    }

    return {configurator: configuratorToUse, onSelect};

}